import "./App.css";
import React from "react";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useParams,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import ScrollToTop from "./Components/scrollTop";

import NigeriaLandingPage from "./Components/Landing Page/Nigeria LP";
import KenyaLandingPage from "./Components/Landing Page/Kenya LP";
import GhanaLandingPage from "./Components/Landing Page/Ghana LP";
import SomaliaLandingPage from "./Components/Landing Page/Somalia LP";
import USLandingPage from "./Components/Landing Page/US LP";
import GlobalLandingPage from "./Components/Landing Page/Global LP";

import FeaturesPage from "./Components/Features Page/Konn3ct FP";
import PricingPage from "./Components/Pricing Page/Kpricing";
import AboutUs from "./Components/About Page/Konn3ctAbout";
import CustomerPage from "./Components/Customers Page/Konn3ctCustomer";
import EventsPage from "./Components/Events/Konn3ctEvents";
import EventDetails from "./Components/Events/KonnectEventId";

import {
  CountryProvider,
  useCountry,
} from "./Components/Context/CountryContext";
import GeoRedirect from "./Components/Geo/GeoRedirect";
import CountryRoute from "./Components/Geo/CountryRoute";

const CountryPageRedirect = ({ page }) => {
  const { country, loading } = useCountry();

  if (loading || !country?.route) {
    return null;
  }

  return <Navigate to={`${country.route}/${page}`} replace />;
};

const LegacyEventRedirect = () => {
  const { ref } = useParams();
  const { country, loading } = useCountry();

  if (loading || !country?.route) {
    return null;
  }

  return (
    <Navigate
      to={`${country.route}/event/${encodeURIComponent(ref)}`}
      replace
    />
  );
};

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <CountryProvider>
          <ScrollToTop />

          <Routes>
            <Route path="/" element={<GeoRedirect />} />

            <Route
              path="/ng"
              element={
                <CountryRoute countryCode="NG">
                  <NigeriaLandingPage />
                </CountryRoute>
              }
            />

            <Route
              path="/ke"
              element={
                <CountryRoute countryCode="KE">
                  <KenyaLandingPage />
                </CountryRoute>
              }
            />

            <Route
              path="/gh"
              element={
                <CountryRoute countryCode="GH">
                  <GhanaLandingPage />
                </CountryRoute>
              }
            />

            {/* Backwards compatibility for /gf */}
            <Route path="/gf" element={<Navigate to="/gh" replace />} />

            <Route
              path="/so"
              element={
                <CountryRoute countryCode="SO">
                  <SomaliaLandingPage />
                </CountryRoute>
              }
            />

            <Route
              path="/us"
              element={
                <CountryRoute countryCode="US">
                  <USLandingPage />
                </CountryRoute>
              }
            />

            <Route
              path="/global"
              element={
                <CountryRoute countryCode="GLOBAL">
                  <GlobalLandingPage />
                </CountryRoute>
              }
            />

            {/* Preserve existing Meet behavior, but make it geo-aware */}
            <Route path="/Meet" element={<GeoRedirect />} />
            <Route path="/meet" element={<GeoRedirect />} />

            {/* Country-scoped public pages */}
            <Route
              path="/:countryCode/features"
              element={
                <CountryRoute>
                  <FeaturesPage />
                </CountryRoute>
              }
            />

            <Route
              path="/:countryCode/customers"
              element={
                <CountryRoute>
                  <CustomerPage />
                </CountryRoute>
              }
            />

            <Route
              path="/:countryCode/pricing"
              element={
                <CountryRoute>
                  <PricingPage />
                </CountryRoute>
              }
            />

            <Route
              path="/:countryCode/about"
              element={
                <CountryRoute>
                  <AboutUs />
                </CountryRoute>
              }
            />

            <Route
              path="/:countryCode/events"
              element={
                <CountryRoute>
                  <EventsPage />
                </CountryRoute>
              }
            />

            <Route
              path="/:countryCode/event/:ref"
              element={
                <CountryRoute>
                  <EventDetails />
                </CountryRoute>
              }
            />

            {/* Legacy root URLs redirect into the active/detected country */}
            <Route
              path="/Features"
              element={<CountryPageRedirect page="features" />}
            />
            <Route
              path="/features"
              element={<CountryPageRedirect page="features" />}
            />
            <Route
              path="/Customers"
              element={<CountryPageRedirect page="customers" />}
            />
            <Route
              path="/customers"
              element={<CountryPageRedirect page="customers" />}
            />
            <Route
              path="/Pricing"
              element={<CountryPageRedirect page="pricing" />}
            />
            <Route
              path="/pricing"
              element={<CountryPageRedirect page="pricing" />}
            />
            <Route
              path="/AboutUs"
              element={<CountryPageRedirect page="about" />}
            />
            <Route
              path="/about"
              element={<CountryPageRedirect page="about" />}
            />
            <Route
              path="/EventsPage"
              element={<CountryPageRedirect page="events" />}
            />
            <Route
              path="/events"
              element={<CountryPageRedirect page="events" />}
            />
            <Route path="/event/:ref" element={<LegacyEventRedirect />} />

            {/* Unknown routes return to the geo-aware entry point */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CountryProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;


// import "./App.css";
// import React from "react";
// import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
// import { HelmetProvider } from "react-helmet-async";

// import ScrollToTop from "./Components/scrollTop";

// import NigeriaLandingPage from "./Components/Landing Page/Nigeria LP";
// import KenyaLandingPage from "./Components/Landing Page/Kenya LP";
// import GhanaLandingPage from "./Components/Landing Page/Ghana LP";
// import SomaliaLandingPage from "./Components/Landing Page/Somalia LP";
// import USLandingPage from "./Components/Landing Page/US LP";
// import GlobalLandingPage from "./Components/Landing Page/Global LP";

// import FeaturesPage from "./Components/Features Page/Konn3ct FP";
// import PricingPage from "./Components/Pricing Page/Kpricing";
// import AboutUs from "./Components/About Page/Konn3ctAbout";

// import EventsPage from "./Components/Events/Konn3ctEvents";
// import EventDetails from "./Components/Events/KonnectEventId";

// import { CountryProvider } from "./Components/Context/CountryContext";
// import GeoRedirect from "./Components/Geo/GeoRedirect";
// import CountryRoute from "./Components/Geo/CountryRoute";

// const App = () => {
//   return (
//     <HelmetProvider>
//       <Router>
//         <CountryProvider>
//           <ScrollToTop />

//           <Routes>
//             <Route path="/" element={<GeoRedirect />} />

//             <Route
//               path="/ng"
//               element={
//                 <CountryRoute countryCode="NG">
//                   <NigeriaLandingPage />
//                 </CountryRoute>
//               }
//             />

//             <Route
//               path="/ke"
//               element={
//                 <CountryRoute countryCode="KE">
//                   <KenyaLandingPage />
//                 </CountryRoute>
//               }
//             />

//             <Route
//               path="/gh"
//               element={
//                 <CountryRoute countryCode="GH">
//                   <GhanaLandingPage />
//                 </CountryRoute>
//               }
//             />

//             {/* Backwards compatibility for /gf */}
//             <Route path="/gf" element={<Navigate to="/gh" replace />} />

//             <Route
//               path="/so"
//               element={
//                 <CountryRoute countryCode="SO">
//                   <SomaliaLandingPage />
//                 </CountryRoute>
//               }
//             />

//             <Route
//               path="/us"
//               element={
//                 <CountryRoute countryCode="US">
//                   <USLandingPage />
//                 </CountryRoute>
//               }
//             />

//             <Route
//               path="/global"
//               element={
//                 <CountryRoute countryCode="GLOBAL">
//                   <GlobalLandingPage />
//                 </CountryRoute>
//               }
//             />

//             {/* Preserve existing Meet behavior, but make it geo-aware */}
//             <Route path="/Meet" element={<GeoRedirect />} />
//             <Route path="/meet" element={<GeoRedirect />} />

//             {/* Existing shared public pages */}
//             <Route path="/Features" element={<FeaturesPage />} />
//             <Route path="/features" element={<FeaturesPage />} />

//             {/* <Route path="/Customers" element={<CustomerPage />} />
//             <Route path="/customers" element={<CustomerPage />} /> */}

//             <Route path="/Pricing" element={<PricingPage />} />
//             <Route path="/pricing" element={<PricingPage />} />

//             <Route path="/AboutUs" element={<AboutUs />} />
//             <Route path="/about" element={<AboutUs />} />

//             {/* Event catalogue and details */}
//             <Route path="/EventsPage" element={<EventsPage />} />
//             <Route path="/events" element={<EventsPage />} />
//             <Route path="/event/:ref" element={<EventDetails />} />

//             {/* Unknown routes return to the geo-aware entry point */}
//             <Route path="*" element={<Navigate to="/" replace />} />
//           </Routes>
//         </CountryProvider>
//       </Router>
//     </HelmetProvider>
//   );
// };

// export default App;

// import './App.css';
// import React from "react";
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import ScrollToTop from "./Components/scrollTop";
// import LandingPage from './Components/Landing Page/Nigeria LP';
// import FeaturesPage from './Components/Features Page/Konn3ct FP';
// import CustomerPage from "./Components/Customers Page/Konn3ctCustomer";
// import PricingPage from './Components/Pricing Page/Kpricing';
// import AboutUs from "./Components/About Page/Konn3ctAbout";

// const App = () => {
//   return (
//     <div>
//       <Router>
//         <ScrollToTop />
//         <Routes>
//           <Route path='/' element={<LandingPage />} />
//           <Route path='/Meet' element={<LandingPage />} />
//           <Route path='/Features' element={<FeaturesPage />} />
//           <Route path='/Customers' element={<CustomerPage />} />
//           <Route path='/Pricing' element={<PricingPage />} />
//           <Route path='/AboutUs' element={<AboutUs />} />
//         </Routes>
//       </Router>

//     </div>
//   );
// };

// export default App;
